import SelectItem from "@/models/components/inputs/selectItem";
import i18n from "@/plugins/i18n";
import { filterCapitalize } from "@/filters/capitalize";

export enum COST_DOCUMENT_STATUSES {
  NotApproved = 0,
  Approved = 1,
  Incomplete = 2,
  //Processing = 3,
  //Scam = 4,
}

export const translatedStatuses = [
  { value: COST_DOCUMENT_STATUSES.NotApproved, text: filterCapitalize(i18n.t("notApproved")) } as SelectItem,
  { value: COST_DOCUMENT_STATUSES.Approved, text: filterCapitalize(i18n.t("approved")) } as SelectItem,
  { value: COST_DOCUMENT_STATUSES.Incomplete, text: filterCapitalize(i18n.t("incomplete")) } as SelectItem,
  //{ value: COST_DOCUMENT_STATUSES.Processing, text: filterCapitalize(i18n.t("processing")) } as SelectItem,
  //{ value: COST_DOCUMENT_STATUSES.Scam, text: filterCapitalize(i18n.t("scam")) } as SelectItem,
];
